import styled from "styled-components"
import PropTypes from "prop-types"

import { FullWidthCardWrapper } from "../../../component-library/components/card/full-width-card-wrapper.component"

import { TextField } from "../../../component-library/components/text-field/text-field.component"
import { RadioButtonGroup } from "../../../component-library/components/radio-button/radio-button.component"
import { Button } from "../../../component-library/components/button/button.component"
import { SPACING } from "../../../component-library/design/spacing/spacing.constants"
import {
  Heading,
  HeadingSmall,
  SmallText,
} from "../../../component-library/design/typography/typography.styles"

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

const StyledOrderInfoForm = styled(FullWidthCardWrapper)`
  width: 620px;
`

const StyledWrapper = styled.div`
  margin: ${SPACING.M} 0;

  &:last-child {
    margin-bottom: 0;
  }
`

const StyledHeading = styled(Heading)`
  margin-bottom: ${SPACING.M};
`

const StyledSubheading = styled(HeadingSmall)`
  margin-bottom: 0;
`

const AdditionalInformation = styled(SmallText)`
  margin-top: ${SPACING.XS};
`

const StyledTextField = styled(TextField)`
  margin-top: ${SPACING.S};
`

const StyledPlaceOrderButton = styled(Button)`
  width: 100%;
  margin-top: ${SPACING.M};
`

const QuotationBox = styled.div`
  width: 300px;
  margin-left: 20px;
  position: sticky;
  top: calc(${SPACING.M} + ${(props) => props.headerBannerHeight});
`

const StyledRadioGroup = styled(({ across, ...props }) => (
  <RadioButtonGroup {...props} />
))`
  // Radio Group Container
  // See https://gogotech.atlassian.net/browse/GGB-535
  [role="radiogroup"] {
    display: flex;
    flex-wrap: wrap;
    margin-top: ${SPACING.S};
  }

  // Radio Button Container
  // See https://gogotech.atlassian.net/browse/GGB-535
  [role="radio"] {
    width: calc(
      ${(props) => 100 / props.across}% -
        (
          ${SPACING.S} * ${(props) => props.across - 1} /
            ${(props) => props.across}
        )
    );
    margin: 0 ${SPACING.S} ${SPACING.S} 0;

    &:nth-last-child(-n + ${(props) => props.across}) {
      margin-bottom: 0;
    }

    &:nth-child(${(props) => props.across}n) {
      margin-right: 0;
    }
  }
`

StyledRadioGroup.propTypes = {
  across: PropTypes.number.isRequired,
}

 const StyledSubheadingWrap = styled.div`
  display: flex;
  margin-bottom: 10px;
`

export {
  RowContainer,
  StyledOrderInfoForm,
  QuotationBox,
  StyledWrapper,
  StyledHeading,
  StyledSubheading,
  AdditionalInformation,
  StyledTextField,
  StyledRadioGroup,
  StyledPlaceOrderButton,
  StyledSubheadingWrap,
}
